module.exports = __webpack_public_path__ + "static/media/features_servicio-domicilio.266d4132.jpg";